import VideoCard from "src/component/VideoCard";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import Slider from "react-slick";
import NoDataFoundFrame from "src/component/NoDataFoundFrame";

const useStyles = makeStyles((theme) => ({
  videoMapBox: {
    position: "relative",
    // overflow: "hidden",
    [theme.breakpoints.down("md")]: {
      overflow: "hidden",
    },

    [theme.breakpoints.down("xs")]: {
      overflow: "visible",
    },
    "& .imageSilderSide": {
      "& img": {
        top: "135px",
        left: "0",
        width: "auto",
        maxWidth: "340px",
        zIndex: "9",
        position: "absolute",
        overflow: "hidden",
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      },
    },
  },
  videosliderBox: {
    position: "relative",
    // left: "150px",
    // padding: "0px 0 30px 30px",
    "@media(max-width:1280px)": {
      left: "0px",
      padding: "46px 0 34px 51px",
    },
    [theme.breakpoints.down("sm")]: {
      left: "0px",
      padding: "6px 0 34px 17px",
      //   padding: "50px 0 30px 10px",
    },
  },
}));

export default function Slidernew({ newsData, IsLoading }) {
  const classes = useStyles();

  const settings = {
    autoplaySpeed: 4000,
    slidesToShow: 4,
    accessibility: false,
    slidesToScroll: 1,
    arrows: true,
    lazyLoad: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          centerPadding: "80px",
          autoplay: true,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          centerPadding: "80px",
          autoplay: true,
        },
      },
      {
        breakpoint: 725,
        settings: {
          slidesToShow: 1,
          centerMode: false,

          autoplay: true,
        },
      },
      {
        breakpoint: 450,
        settings: {
          slidesToShow: 1,
          centerMode: false,

          autoplay: true,
        },
      },
    ],
  };

  return (
    <Box className={classes.videoMapBox}>
      {!IsLoading && newsData && newsData.length === 0 && (
        <Box className="loadertable">
          <NoDataFoundFrame data="No news found" />
        </Box>
      )}
      <Box className={`${classes.videosliderBox} newsBox`}>
        <Slider {...settings} className="slickbottomslider">
          {newsData &&
            newsData?.map((value, index) => (
              <VideoCard value={value} index={index} />
            ))}
        </Slider>
      </Box>
    </Box>
  );
}
